import React from "react";
import { useController } from "react-hook-form";
import styled from "styled-components";

const FormNameDiv = styled.div`
  width: ${(props) => props.width};
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  @media (max-width: 475px) {
    width: 100%;
  }
`;

const FormNameInput = styled.input`
  width: 100%;
  height: 30px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 1rem;
  font-family: var(--roboto);
  padding-left: 0.5rem;
`;

const FormNameTextArea = styled.textarea`
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  min-height: 80px;
  max-height: 80px;
  height: 80px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0.5rem;
  font-family: var(--roboto);
  @media (max-width: 675px) {
    min-height: 100px;
    max-height: 100px;
    min-width: 100%;
    max-width: 100%;
  }
`;

const FormNameLabel = styled.label`
  font-family: var(--roboto);
  font-size: 0.8rem;
  color: var(--white);
`;

const ErrorMsg = styled.p`
  color: red;
  font-size: 0.8rem;
  font-family: var(--roboto);
`;

const Input = ({
  id,
  width,
  type,
  placeholder,
  label,
  textArea,
  error,
  control,
  name,
  rules,
}) => {
  const { field } = useController({
    name,
    control,
    rules,
    defaultValue: "",
  });

  const selectedInput = textArea ? (
    <FormNameTextArea
      {...field}
      id={id}
      placeholder={placeholder}
      name={name}
      label={label}
    />
  ) : (
    <FormNameInput
      {...field}
      type={type}
      id={id}
      placeholder={placeholder}
      name={name}
      label={label}
    />
  );

  return (
    <FormNameDiv width={width}>
      <FormNameLabel htmlFor={id}>{label}</FormNameLabel>
      {selectedInput}
      {error && <ErrorMsg>{error.message}</ErrorMsg>}
    </FormNameDiv>
  );
};

export default Input;
